import script from "./log-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./log-detail.vue?vue&type=script&setup=true&lang=js"

import "./log-detail.vue?vue&type=style&index=0&id=854463fe&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-854463fe"]])

export default __exports__